import { ReactNode } from 'react';
import { SupportCasesItem } from '../../../types';
import { TextBlock } from '../../Atoms/Text';
import { DetailViewCard } from '../CardWithTitle';
import { ComponentSpinner } from '../Loading/ComponentSpinner';
import { CaseLink } from '../UpstackDataGrid/CellRenderers';

export interface SupportCasesCardProps {
  title: string;
  cases: SupportCasesItem[];
  emptyText: string;
  loading?: boolean;
  processing?: boolean;
  disabledMessage?: string;
  note?: string;
  cardActions?: ReactNode;
  enableCollapse?: boolean;
  collapsed?: boolean;
  testId?: string;
}

export function SupportCasesCard({
  title,
  cases,
  emptyText,
  loading = false,
  processing = false,
  disabledMessage,
  note,
  cardActions,
  enableCollapse = false,
  collapsed = false,
  testId = 'table'
}: SupportCasesCardProps) {
  return (
    <DetailViewCard
      cardActions={cardActions}
      collapsed={collapsed}
      enableCollapse={enableCollapse}
      title={title}>
      <div className="max-h-72">
        {(loading || processing) && (
          <div className="mt-28">
            <ComponentSpinner />
          </div>
        )}
        {!disabledMessage && !loading && !cases.length && <div className="text-center">{emptyText}</div>}
        {disabledMessage && <div className="text-center">{disabledMessage}</div>}
        {!loading && !!cases.length && (
          <div className="h-60 overflow-auto">
            <table
              data-testid={testId}
              className="w-full [&_tr]:border-y [&_tr]:h-[30px]">
              <thead>
                <tr className="text-indigo-mid text-xs text-left [&>*]:font-normal truncate [&>*]:p-2">
                  <th className="border-r"></th>
                  <th className="border-r">Status</th>
                  <th className="border-r">Case Number</th>
                  <th className="border-r">Issue</th>
                  <th className="border-r">Date/Time Opened</th>
                </tr>
              </thead>
              <tbody className="h-2/3 overflow-scroll">
                {cases.map((case_) => (
                  <tr
                    key={`${case_.caseNumber}-${case_.id}`}
                    className="text-black text-sm text-left font-normal truncate [&>*]:p-[0.65rem]">
                    <td className="pt-[-20px] border-r min-w-[38px]">
                      <CaseLink
                        data={case_}
                        classNames="h-[100%]"
                      />
                    </td>
                    <td className="border-r min-w-[90px] text-ellipsis">{case_.status}</td>
                    <td className="border-r min-w-[100px]">{case_.caseNumber}</td>
                    <td className="border-r min-w-[100px]">{case_.issue}</td>
                    <td className="border-r min-w-[100px]">{case_.dateTimeOpened}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {note && !loading && (
          <TextBlock
            className="mt-3 px-2"
            color="grey6"
            size="sm">
            {note}
          </TextBlock>
        )}
      </div>
    </DetailViewCard>
  );
}
